import React, { useState } from 'react';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import InvoiceList from './InvoiceList';
import InvoiceDetail from './InvoiceDetail';
import InvoiceGenerate from './InvoiceGenerate';

const InvoiceModule = ({ projectId, projectName = "Project" }) => {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'detail', 'generate'
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleSelectInvoice = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setCurrentView('detail');
  };

  const handleGenerateInvoice = () => {
    setCurrentView('generate');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedInvoiceId(null);
  };

  const handleGenerateSuccess = () => {
    setCurrentView('list');
    setRefreshTrigger(prev => prev + 1);
  };

  const renderBreadcrumb = () => {
    return (
      <Breadcrumb className="mb-4">
        <BreadcrumbItem>
          <i className="nc-icon nc-bank mr-1" />
          {projectName}
        </BreadcrumbItem>
        <BreadcrumbItem active={currentView === 'list'}>
          Invoices
        </BreadcrumbItem>
        {currentView === 'detail' && (
          <BreadcrumbItem active>
            Invoice Detail
          </BreadcrumbItem>
        )}
        {currentView === 'generate' && (
          <BreadcrumbItem active>
            Generate Invoice
          </BreadcrumbItem>
        )}
      </Breadcrumb>
    );
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'detail':
        return (
          <InvoiceDetail
            projectId={projectId}
            invoiceId={selectedInvoiceId}
            onBack={handleBackToList}
          />
        );
      case 'generate':
        return (
          <InvoiceGenerate
            projectId={projectId}
            onSuccess={handleGenerateSuccess}
            onCancel={handleBackToList}
          />
        );
      default:
        return (
          <InvoiceList
            projectId={projectId}
            onSelectInvoice={handleSelectInvoice}
            onGenerate={handleGenerateInvoice}
            refreshTrigger={refreshTrigger}
          />
        );
    }
  };

  return (
    <div className="content">
      <Container fluid>
        <Row>
          <Col>
            {renderBreadcrumb()}
            {renderCurrentView()}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default InvoiceModule;